// extracted by mini-css-extract-plugin
export default {"tagCountContainer":"styles_tagCountContainer__zxVqE","countContainer":"styles_countContainer__hP39N","pointer":"styles_pointer__k9ovh"};